import React from "react";

function CompanyLogo({ Logo, params }) {
  return <img src={`${Logo}`} alt="CompanyLogo" width={"45%"} />;
}

export default CompanyLogo;
